<template>
  <div
    class="payment-message-container d-flex flex-column justify-content-center text-center"
  >
    <template v-if="paymentStatus == 'pending'">
      <div class="mb-3">
        <img class="clock-icon" src="@/assets/images/clock.png" />
      </div>
      <div class="processing mb-2">Payment is processing</div>
      <div class="processing-details mb-4">
        We are processing your payment. Kindly wait for a while.
      </div>
      <div class="do-not-close mb-3">PLEASE DO NOT CLOSE THE WINDOW</div>

      <div class="do-not-close">00:{{ formattedCountDown }}</div>
    </template>

    <template v-if="paymentStatus == 'failed'">
      <div class="mb-3">
        <img class="clock-icon" src="@/assets/images/failed.png" />
      </div>
      <div class="processing mb-2">Payment Failed</div>
      <div class="processing-details mb-4">
        Oops! It looks like there was an issue processing this
        <br />transaction. Please try another payment option.
      </div>
      <div>
        <b-button
          class="b-payment"
          variant="primary"
          @click="
            () => {
              this.$router.push({ name: 'wallet-topup' });
            }
          "
          >Try Again</b-button
        >
      </div>
    </template>

    <template v-if="paymentStatus == 'expired'">
      <div class="mb-3">
        <img class="clock-icon" src="@/assets/images/expired.png" />
      </div>
      <div class="processing mb-2">Payment Expired</div>
      <div class="processing-details mb-4">
        Payment {{ paymentIntentId }} has expired<br />status
      </div>
      <div>
        <b-button
          class="b-payment"
          variant="primary"
          @click="
            () => {
              this.$router.push({ name: 'wallet-topup' });
            }
          "
          >Try Again</b-button
        >
      </div>
    </template>
  </div>
</template>

<script>
import { walletMethods, walletComputed } from "@/state/helpers";

export default {
  props: ["status", "module", "skuAmount", "methodId"],
  data() {
    return {
      paymentStatus: this.status,
      paymentIntentId: null,
      timerCount: 10,
    };
  },
  watch: {
    timerCount: {
      handler(value) {
        if (this.paymentStatus == "pending") {
          if (value > 1) {
            setTimeout(() => {
              this.timerCount--;
              // Per second checking
              this.modeTwoStatus({
                module: "kanto_ads",
                intentId: this.paymentIntentId,
              })
                .then((res) => {
                  if (
                    res.status == "ok" &&
                    res.message.data.logData.status == 'success'
                  ) {
                    this.redirectTopupPage();
                  } else if (
                    res.status == "ok" && 
                    res.message.data.attributes.status != "succeeded"
                  ) {
                    this.paymentStatus = "failed";
                  }
                })
                .catch((err) => {
                  console.log(err);
                  this.paymentStatus = "failed";
                });
            }, 1000);
          } else {
            this.redirectTopupPage();
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...walletComputed,
    formattedCountDown() {
      return this.timerCount.toString().padStart(2, "0");
    },
  },
  methods: {
    ...walletMethods,
    redirectTopupPage() {
      this.$router.push({
        name: "wallet-topup",
        query: {
          status: this.paymentStatus,
          module: this.module,
          skuAmount: this.skuAmount,
          methodId: this.methodId,
          paymentIntentId: this.paymentIntentId,
        },
      });
    },
  },
  mounted() {
    this.paymentIntentId = this.$route.query.payment_intent_id;
    console.log(this.paymentIntentId);
  },
};
</script>

<style>
.payment-message-container {
  height: 80vh;
}

.clock-icon {
  height: 42px;
}

.processing {
  font-size: 24px;
  font-weight: 500;
}

.processing-details {
  font-size: 14px;
  font-weight: 400;
}

.do-not-close {
  font-size: 14px;
  font-weight: 700;
  color: #bc3d40;
}

.b-payment {
  width: 400px;
  height: 55px;
}
</style>